/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { FC } from 'react';

import { Carousel } from '@mantine/carousel';
import { Divider, Flex, Loader, Stack, Text } from '@mantine/core';

import { PlaceLocation } from '@/entities/PlaceLocation';

// import { MapButton } from '@/shared/uikit/components/button/mapButton';
import { useGetBookingTypeData } from '@/shared/hooks/useGetBookingTypeData';
import { IBookingRadar } from '@/shared/types/booking.types';
import { ContentCheckbox } from '@/shared/uikit/components/checkbox/contentCheckbox';

dayjs.extend(duration);

type RadarDetailProps = {
	object: IBookingRadar;
	type?: 'detail' | 'free' | 'limited';
};

export const RadarDetail: FC<RadarDetailProps> = ({ object, type = 'detail' }) => {
	const objectType = useGetBookingTypeData({
		bookingType: object?.object_kind,
	});
	const activeTime = dayjs(object?.stop_at).diff(dayjs(), 'minute');

	// const actionType = dayjs().isBetween(object.start, object.end) ? 'end' : 'cancel';

	// const [openedFreeAccess, { close: closeFreeAccess, open: openFreeAccess }] = useDisclosure(false);

	// const [openedLimitedAccess, { close: closeLimitedAccess, open: openLimitedAccess }] =
	// 	useDisclosure(false);

	// const [openedFreeAccessEdit, { close: closeFreeAccessEdit, open: openFreeAccessEdit }] =
	// 	useDisclosure(false);

	// const [openedLimitedAccessEdit, { close: closeLimitedAccessEdit, open: openLimitedAccessEdit }] =
	// 	useDisclosure(false);

	// const [openedEditActions, { close: closeEditActions, open: openEditActions }] =
	// 	useDisclosure(false);

	if (!object) return null;

	return (
		<>
			<Flex direction="column" gap={24}>
				<Carousel
					withControls={false}
					w="100%"
					slidesToScroll="auto"
					slideSize="auto"
					slideGap={8}
					align="start"
					style={{ pointerEvents: 'none' }}
				>
					<Carousel.Slide>
						<ContentCheckbox label={objectType?.label} leftIcon={objectType?.icon} checked />
					</Carousel.Slide>
				</Carousel>

				<Flex justify="space-between">
					<Flex direction="column" maw={400}>
						<Text size="lg" fw={600}>
							Ищем свободное место
						</Text>
						<Text c="dimmed" size="md" fw={500}>
							{`Поиск будет активен до ${dayjs(object?.stop_at).format('DD MMMM HH:mm')}`}
						</Text>
					</Flex>
					<Flex align="center" gap={5}>
						<Loader size="sm" />
					</Flex>
				</Flex>

				<Stack gap={16}>
					<Flex align="center" justify="space-between" gap={16}>
						<Flex direction="column">
							<Text size="lg" fw={600} lh="20px">
								Радар
							</Text>
							<Text c="dimmed" size="md" fw={500} lh="18px">
								Как только освободится место - сразу пришлем уведомление
							</Text>
						</Flex>
					</Flex>

					{!object.only_notify && (
						<Flex align="center" justify="space-between" gap={16}>
							<Flex direction="column">
								<Text size="lg" fw={600} lh="20px">
									Автобронирование
								</Text>
								<Text c="dimmed" size="md" fw={500} lh="18px">
									Сразу забронируем освободившееся место
								</Text>
							</Flex>
						</Flex>
					)}
					<Divider color="#6670851A" />
					<Flex direction="column" justify="space-between" gap={16}>
						<Flex direction="column">
							<Text size="lg" fw={600} lh="20px">
								Время поиска
							</Text>
							<Text c="dimmed" size="md" fw={500} lh="18px">
								{`Радар будет включен в течение: ${dayjs.duration(activeTime, 'minutes').format('D [д.] H [ч.] m [мин.]')}`}
							</Text>
						</Flex>
					</Flex>
				</Stack>

				{type === 'detail' && (
					<Flex direction="column" gap={8}>
						<Text size="xl" fw={800}>
							Дата и время
						</Text>
						<Flex gap={16}>
							<Flex direction="column" pr={10}>
								<Text c="#667085" size="sm" fw={500} tt="uppercase">
									Дата
								</Text>
								<Text fw={600}>
									{dayjs(object?.start).date() === dayjs(object?.end).date()
										? `${dayjs(object?.start).format('DD MMM')}`
										: `С ${dayjs(object?.start).format('DD MMM')} до ${dayjs(object?.end).format('DD MMM')}`}
								</Text>
							</Flex>
							<Flex direction="column" pr={10}>
								<Text c="#667085" size="sm" fw={500} tt="uppercase">
									Время
								</Text>
								<Text fw={600}>
									{`${dayjs(object?.start).format('HH:mm')} - ${dayjs(object?.end).format('HH:mm')}`}
								</Text>
							</Flex>
						</Flex>
					</Flex>
				)}

				<Flex direction="column" gap={18}>
					<Text size="xl" fw={800}>
						Локация
					</Text>
					<Flex gap={16}>
						<Flex direction="column">
							<Text c="#667085" size="sm" fw={500} tt="uppercase">
								Офис и этаж
							</Text>
							<Text fw={600}>
								{object.description}
								<PlaceLocation placeId={object.booking_object_id} depth={10} />
							</Text>
						</Flex>
					</Flex>
					<Flex gap={16}>
						<Flex direction="column">
							<Text c="#667085" size="sm" fw={500} tt="uppercase">
								{objectType?.label}
							</Text>
							<Text fw={600}>{object.object_kind && 'Любое'}</Text>
						</Flex>
					</Flex>
				</Flex>
				{/* <MapButton objects={object} text="Открыть на карте" showOnMap /> */}
			</Flex>

			{/* <BottomSheet
				opened={openedLimitedAccess}
				onClose={closeLimitedAccess}
				title="Ограниченный доступ"
				buttons={[
					{
						children: actionType === 'cancel' ? 'Отменить' : 'Завершить',
						variant: 'default',
						// onClick: openActions,
					},
					{
						children: 'Редактировать',
						color: 'green',
						// onClick: openEdit
					},
				]}
				withCloseButton={false}
				withBackButton
				isFullScreen
			>
				<PersonalPlaceDetail object={object} type="limited" />
			</BottomSheet> */}

			{/* {openedFreeAccessEdit && (
				<PersonalPlaceEdit
					object={object}
					opened={openedFreeAccessEdit}
					close={closeFreeAccessEdit}
					type="editFree"
					isAccess={object?.active}
				/>
			)} */}

			{/* {openedLimitedAccessEdit && (
				<PersonalPlaceEdit
					object={object}
					opened={openedFreeAccessEdit}
					close={closeLimitedAccessEdit}
					type="editLimited"
					isAccess={object?.active}
				/>
			)} */}

			{/* {object.release_id && (
				<PersonalPlaceActions
					id={object.release_id}
					type={actionType}
					opened={openedEditActions}
					close={closeEditActions}
				/>
			)} */}
		</>
	);
};
